
import React, {FC} from 'react';
import {useLocation} from '@reach/router';
import classNames from 'classnames';
import {NavProps} from 'components/Header';
import {Link} from 'components/Header/navs';
import StyledLink from 'components/Header/shared/StyledLink';
import {navigate} from 'gatsby';

import * as styles from './styles.module.scss';

export const handleClick = (nav: NavProps['nav'], target: string) => (
	(e: React.MouseEvent) => {
		const [targetPath, targetHash] = target.split('#');

		// Create function to force a UI update
		const updateUI = () => {
			if (nav.active) {
				nav.close();
				e.stopPropagation();
			} else {
				// Reload page to exit dropdown desktop nav
				window.location.reload();
			}
		};

		// Path mismatch, navigate and exit => no additional UI update needed
		if (location.pathname !== targetPath) {
			navigate(target);
			return;
		}

		// Same path but hash mismatch, update and manually force UI change
		if (location.hash !== (targetHash ? '#' + targetHash : '')) {

			if (nav.active) {
				navigate(target);
				updateUI();
			} else {
				// In order to both navigate to the target and close the dropdown
				// desktop nav, we add the target to history and then reload
				window.history.pushState(null, '', target);
				window.location.reload();
			}

			return;
		}

		// We have a path & hash match, make sure we have a UI update that we can do
		updateUI();
	}
);

type LinkProps = NavProps & {
	link: Link
}

const _Link: FC<LinkProps> = ({nav, link}) => {
	const {pathname, hash} = useLocation();
	return (
		<a onClick={handleClick(nav, link.link)} className={classNames({
			[styles.standard]: true,
			[styles.highlighted]: (pathname + hash) === link.link,
		})}>
			<StyledLink link={link} />
		</a>
	);
};

export default _Link;

